export class DialogCssCollection {
    static readonly flexHeight = 'flex_height'
}
